// extracted by mini-css-extract-plugin
export default {"UiLoader":"UiLoader_UiLoader__pNKuh","UiLoaderInvisible":"UiLoader_UiLoaderInvisible__2lppB"};